import { FC, useEffect, useState } from 'react'
import { KTIcon } from '../../../../helpers'
import { useLayout } from '../../../../layout/core'

type UserDetails = {
  id: string
  email: string
  username: string
  mobile_number: string
  has_kyc: boolean
  name: string
  lastname: string
  created_at: string
  is_active: boolean
}

const DrawerUserDetails: FC = () => {
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null)
  const { selectedUserDetails } = useLayout()

  useEffect(() => {
    if (selectedUserDetails) {
      setUserDetails(selectedUserDetails)
    }
  }, [selectedUserDetails])

  return (
    <div
      id='user-details-drawer'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='user-details'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'lg': '600px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#user-details-drawer-toggle'
      data-kt-drawer-close='#user-details-close'
    >
      <div className='card rounded-0 w-100'>
        {/* Header */}
        <div className='card-header'>
          <h3 className='card-title fw-bolder text-dark'>User Details</h3>
          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='user-details-close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className='card-body'>
          {!userDetails ? (
            <div className='text-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <div className='d-flex flex-column gap-5'>
              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>First Name:</span>
                <span className='fw-semibold text-dark'>{userDetails.name}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Last Name:</span>
                <span className='fw-semibold text-dark'>{userDetails.lastname}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Email ID:</span>
                <span className='fw-semibold text-dark'>{userDetails.email}</span>
              </div>

              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>PayAiro Tag:</span>
                <span className='fw-semibold text-dark'>{userDetails.username}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Mobile No.:</span>
                <span className='fw-semibold text-dark'>{userDetails.mobile_number}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>KYC Status:</span>
                <span
                  className={`badge ${userDetails.has_kyc ? 'badge-light-success' : 'badge-light-danger'
                    } fw-semibold`}
                >
                  {userDetails.has_kyc ? 'Completed' : 'Uncompleted'}
                </span>
              </div>


              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Created At:</span>
                <span className='fw-semibold text-dark'>
                  {new Date(userDetails.created_at).toLocaleString()}
                </span>
              </div>

              <div className='d-flex align-items-center justify-content-between'>
                <span className='fw-bold fs-6 text-gray-600'>Status:</span>
                <span
                  className={`badge ${userDetails.is_active ? 'badge-light-success' : 'badge-light-danger'
                    } fw-semibold`}
                >
                  {userDetails.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { DrawerUserDetails }
